import { KAMBI_ROOT_ROUTE } from '@core/Areas/KambiClient/constants'

export const getEventLinkForKambiClient = (eventId: number) => {
  return `/${KAMBI_ROOT_ROUTE}/event/${eventId}`
}
